<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2  style=" color:white; text-align:  center; margin-bottom: 10px"  > 
    Early Childhood Development Program (ECDP)
  </h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: cover; border-radius: 10px"
      src="assets/img/school/news/6.jpeg"
    />
  </div>
  <br />
  <br />
  <div
    class="container"
    style="text-align: justify !important;">
    <div class="row">
      <div class="col-md-12">
        <p style="color: white;">
          Early Childhood Development Program (ECDP) can be defined as a program
          that helps the holistic development of children including physical,
          cognitive, language, social and emotional development from age two to
          age six. Early intervention and special education programs provide
          support and services to children with disabilities so they can
          develop, learn and grow to reach their fullest potential.
          Proyash-Chattogram ensures a high-quality early childhood development
          program that provides a safe and nurturing environment while promoting
          the physical, social, emotional, and intellectual development of young
          children. Skills that ECDP aims at physical and motor development,
          cognitive development, communication & linguistic development,
          personal and social development, emotional development, values and
          moral development and activities of daily living etc. Steps involved
          in the Early Childhood Development Program are initiating future
          learning capacity, behavior management, improving physical and mental
          health, supporting responsive relationships, strengthening core
          skills, and reducing sources of stress. Proyash-Chattogram ECDP
          started her journey in 2013 with a few students, which has now reached
          100 students, accumulating the morning shift and day shift. More than
          14 teachers and 14 teaching assistants are directly involved in
          forming a better future for these children with different and special
          needs. Activities of Proyash-Chattogram ECDP consist of numerous group
          activities, individual activities, therapeutic sessions, parents'
          counselling as well as providing a home management plan. <br />
          The purpose of Early childhood development program (ECDP) is to
          enable; <br />
          <br />
          • Engagement of children in a wide range of learning experiences to
          maximize their individual potential. <br />
          • Assessment of educational support needs prior to prep aged children,
          Establishment of partnerships with families to ensure quality
          educational outcomes in the critical early years of schooling.
        </p>
      </div>
    </div>
  </div>
</div>
